import * as React from 'react';
import {
  Box,
  ParagraphText,
  UtilityText,
  StackLayout,
} from '@leagueplatform/genesis-core';
import { Carousel } from '@leagueplatform/web-common-components';
import { SenderAvatar } from './sender-avatar.component';

const MessageContent = ({
  content,
  children,
  onNextClick,
  onPreviousClick,
}: {
  content?: string;
  children?: React.ReactNode;
  onNextClick?: () => void;
  onPreviousClick?: () => void;
}): React.ReactElement => {
  const childArray = React.Children.toArray(children);
  const hasItems = childArray.length > 0;

  return (
    <StackLayout spacing="$one" css={{ maxWidth: '100%' }}>
      {content && (
        <Box>
          <ParagraphText size="sm">{content}</ParagraphText>
        </Box>
      )}
      {hasItems &&
        (childArray.length === 1 ? (
          childArray[0]
        ) : (
          <Box
            css={{
              maxWidth: '100%',
              '> *': {
                maxWidth: '100%',
              },
            }}
          >
            <Carousel
              name="chat-history-cards"
              spaceBetweenCards="half"
              listStyles={{ minWidth: '280px' }}
              BackNavButtonAnalyticsFn={onPreviousClick}
              ForwardNavButtonAnalyticsFn={onNextClick}
            >
              {childArray}
            </Carousel>
          </Box>
        ))}
    </StackLayout>
  );
};

export const MessageBubble = ({
  senderName,
  senderAvatar,
  timestamp,
  content,
  children,
  onNextClick,
  onPreviousClick,
}: {
  senderName?: string;
  senderAvatar?: string;
  timestamp: string;
  content?: string;
  children?: React.ReactNode;
  onNextClick?: () => void;
  onPreviousClick?: () => void;
}): React.ReactElement => (
  <StackLayout spacing="$threeQuarters" css={{ maxWidth: '100%' }}>
    <StackLayout
      orientation="horizontal"
      spacing="$half"
      css={{
        alignItems: 'center',
      }}
    >
      <SenderAvatar senderAvatar={senderAvatar} senderName={senderName} />
      <StackLayout spacing="$none">
        {senderName && (
          <UtilityText css={{ fontWeight: 'bold', display: 'block' }}>
            {senderName}
          </UtilityText>
        )}
        <UtilityText css={{ typography: '$caption' }}>{timestamp}</UtilityText>
      </StackLayout>
    </StackLayout>
    <MessageContent
      content={content}
      onNextClick={onNextClick}
      onPreviousClick={onPreviousClick}
    >
      {children}
    </MessageContent>
  </StackLayout>
);
